var _a, _b, _c, _d;
import { get, writable } from 'svelte/store';
import { LS } from './shared';
import { LS_IS_DARK_MODE_KEY, LS_RECENT_USAGE_KEY } from './shared/constants';
import { LINK_TYPE } from './shared/links';
export const recentUsedList = writable(LS.get(LS_RECENT_USAGE_KEY, [LINK_TYPE.google]));
export const selectedLinkType = writable((_b = (_a = get(recentUsedList)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : LINK_TYPE.google);
recentUsedList.subscribe(value => {
    LS.set(LS_RECENT_USAGE_KEY, value);
});
export const isDarkMode = writable(LS.get(LS_IS_DARK_MODE_KEY) ||
    (__SERVER__
        ? false
        : (_d = (_c = window.matchMedia) === null || _c === void 0 ? void 0 : _c.call(window, '(prefers-color-scheme: dark)')) === null || _d === void 0 ? void 0 : _d.matches));
isDarkMode.subscribe(val => {
    val = !!val;
    LS.set(LS_IS_DARK_MODE_KEY, !!val);
});
